import { FC, useState } from "react";
import { toast } from "react-toastify";

import { CheckIcon, CrossIcon, EditV2Icon } from "../../../../assets/img/icons";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import { updateUserPassword } from "../../../../services/api/user";

import styles from "./styles.module.scss";
import { AxiosError } from "axios";
import {
    FieldErrors,
    REQUIRED_FIELD,
    clearFieldError,
    formatErrors,
    notifyFieldErrors,
    setFieldErrors as buildFieldErrors,
} from "../../../../utils/errors";
import { useMediaQuery } from "@mui/material";

const Security: FC = () => {
    const [editMode, setEditMode] = useState(false);
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [fieldErrors, setFieldErrors] = useState<FieldErrors>({});

    const isMobile = useMediaQuery("(max-width: 1050px)");

    const handleSave = async () => {
        const nextErrors = buildFieldErrors(
            ["password", !password && REQUIRED_FIELD],
            ["newPassword", !newPassword && REQUIRED_FIELD],
            ["confirmPassword", !confirmPassword && REQUIRED_FIELD]
        );
        if (
            newPassword &&
            confirmPassword &&
            newPassword !== confirmPassword
        ) {
            nextErrors.confirmPassword =
                "Les mots de passe ne correspondent pas.";
        }
        setFieldErrors(nextErrors);
        const mismatch =
            nextErrors.confirmPassword ===
            "Les mots de passe ne correspondent pas.";
        const toastMessage = mismatch
            ? "Les mots de passe ne correspondent pas."
            : (Object.values(nextErrors)[0] ??
              "Veuillez entrer votre mot de passe actuel.");
        if (
            notifyFieldErrors(nextErrors, {
                message: toastMessage,
                type: "error",
            })
        ) {
            return;
        }

        try {
            await updateUserPassword(password, newPassword, confirmPassword);
            setEditMode(false);
            toast.success("Le mot de passe a bien été mis à jour.");
        } catch (error) {
            if (error instanceof AxiosError && error.response?.data.errors) {
                setFieldErrors(formatErrors(error.response.data.errors));
            } else {
                toast.error("Une erreur est survenue lors de la mise à jour.");
            }
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.title}>Informations de connexion</span>
                {editMode ? (
                    <div className={styles.buttons_container}>
                        <Button
                            onClick={() => setEditMode(false)}
                            variant="outlined"
                            className={styles.edit_button}
                            Icon={isMobile ? CrossIcon : undefined }
                            label={isMobile ? "" : "Annuler"}
                            size="small"
                        />
                        <Button
                            onClick={() => handleSave()}
                            variant="outlined"
                            className={styles.edit_button}
                            Icon={isMobile ? CheckIcon : undefined }
                            label={isMobile ? "" : "Sauvegarder"}
                            size="small"
                        />
                    </div>
                ) : (
                    <Button
                        onClick={() => setEditMode(true)}
                        variant="outlined"
                        LeftIcon={EditV2Icon}
                        className={styles.edit_button}
                        label={isMobile ? "" : "Editer informations"}
                        size="small"
                    />
                )}
            </div>
            <div className={styles.content}>
                {editMode ? (
                    <div className={styles.inputs_container}>
                        <Input
                            type="password"
                            className={styles.account_form_input}
                            label="Mot de passe"
                            placeholder="Mot de passe"
                            value={password}
                            onChanged={(value) => {
                                setPassword(value);
                                setFieldErrors((prev) =>
                                    clearFieldError(prev, "password")
                                );
                            }}
                            error={fieldErrors.password}
                        />
                        <Input
                            type="password"
                            className={styles.account_form_input}
                            label="Nouveau mot de passe"
                            placeholder="Nouveau mot de passe"
                            value={newPassword}
                            onChanged={(value) => {
                                setNewPassword(value);
                                setFieldErrors((prev) =>
                                    clearFieldError(prev, "newPassword")
                                );
                            }}
                            error={fieldErrors.newPassword}
                        />
                        <Input
                            type="password"
                            className={styles.account_form_input}
                            label="Confirmer mot de passe"
                            placeholder="Confirmer mot de passe"
                            value={confirmPassword}
                            onChanged={(value) => {
                                setConfirmPassword(value);
                                setFieldErrors((prev) =>
                                    clearFieldError(prev, "confirmPassword")
                                );
                            }}
                            error={fieldErrors.confirmPassword}
                        />
                    </div>
                ) : (
                    <div className={styles.line}>
                        <div className={styles.item}>
                            <span className={styles.label}>Mot de passe</span>
                            <span className={styles.value}>
                                •••••••••••••••••
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Security;
